<template>
  <DoughnutChart :height="1000" :chart-data="data" :options="options"></DoughnutChart>
</template>

<script>
import {Chart, registerables} from 'chart.js';

Chart.register(...registerables);
import {DoughnutChart} from 'vue-chart-3';

export default {
  name: "ChamadosPorPrioridade",
  components: {
    DoughnutChart
  },
  props: ['data'],
  setup() {
    const options = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        title: {
          display: true,
          text: 'Chamados',
          align: 'start',
          font: {
            size: 20,
            weight: 'bold',
            lineHeight: 1.2,
          },
        },
        subtitle: {
          display: true,
          text: 'Por Prioridade',
          align: 'start',
          padding: {
            bottom: 20
          }
        }
      },
    };
    return {options};
  }
}
</script>

<style>

</style>